import { Component, Input, OnChanges, OnInit, SimpleChange, SimpleChanges } from '@angular/core';
import { IndicatorsService } from '../../../../../services/indicators/indicators.service';
import { isUndefined } from 'util';
import { Point } from '../../../../../models/pointWidget.model';

@Component({
  selector: 'app-fondo-di-accantonamento-indicator',
  templateUrl: './fondo-di-accantonamento-indicator.component.html',
  styleUrls: ['./fondo-di-accantonamento-indicator.component.css']
})
export class FondoDiAccantonamentoIndicatorComponent implements OnInit, OnChanges {

  @Input() data: any;
  pointData: Point;

  constructor(
    private indicatorService: IndicatorsService
  ) { }

  ngOnInit() {
    console.log('Init app-fondo-di-accantonamento-indicator', this.data);
    if (!isUndefined(this.data)) {
      this.indicatorService.indicatorCalculation('FondoDiAccantonamento', this.data).subscribe((res) => {
        this.pointData = res[0];
      });
    }
  }

  ngOnChanges(changes: {[ propName: string]: SimpleChange}) {
    if (!isUndefined(changes['data'].currentValue)) {
      this.ngOnInit();
      console.log('Changes', changes['data'].currentValue);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/widgets/points/fondo-di-accantonamento-indicator/fondo-di-accantonamento-indicator.component.ts